<form #blockInputs="ngForm">
  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.SIMPLE_TABLE_BLOCK.TABLE_CONTENT' | translate }}</glxy-label>

    @for (item of content.tableData; track fixFieldLosingFocusWhenTyping(i, item); let i = $index) {
      <div class="table-row">
        <div class="handle"></div>
        <div class="inputs">
          <div class="input-wrapper">
            <textarea
              #label
              #labelModel="ngModel"
              [(ngModel)]="content.tableData[i].label"
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5"
              placeholder="{{ 'EMAIL_BUILDER.SIMPLE_TABLE_BLOCK.LABEL' | translate }}"
              autocomplete="off"
              name="simple-table-label-{{ i }}"
              sharedContainsValidDynamicContent
            ></textarea>
            <email-dynamic-component-selector glxySuffix [target]="label" [(model)]="content.tableData[i].label" />
          </div>
          <div class="input-wrapper">
            <textarea
              #value
              #valueModel="ngModel"
              [(ngModel)]="content.tableData[i].value"
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5"
              placeholder="{{ 'EMAIL_BUILDER.SIMPLE_TABLE_BLOCK.VALUE' | translate }}"
              autocomplete="off"
              name="simple-table-value-{{ i }}"
              sharedContainsValidDynamicContent
            ></textarea>
            <email-dynamic-component-selector glxySuffix [target]="value" [(model)]="content.tableData[i].value" />
          </div>
        </div>
        <button
          mat-icon-button
          class="remove-row"
          (click)="removeRow(i)"
          [matTooltip]="'EMAIL_BUILDER.SIMPLE_TABLE_BLOCK.REMOVE_ROW' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
      @if (
        (labelModel.hasError('invalidDynamicComponent') && labelModel.touched) ||
        (valueModel.hasError('invalidDynamicComponent') && valueModel.touched)
      ) {
        <glxy-error>
          {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
        </glxy-error>
      }
    }
  </glxy-form-field>
</form>

<button mat-stroked-button (click)="addRow()">{{ 'EMAIL_BUILDER.SIMPLE_TABLE_BLOCK.ADD_ROW' | translate }}</button>
